<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-clipboard-list-check" class="q-mb-sm" /> {{ $t('courses_catalog') }}
        </div>

        <q-table
            :data="courses_catalog"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top" slot-scope="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                <div class="col" />

                <q-btn color="secondary" icon="far fa-plus" :label="$t('new')" @click="$router.push({ name: 'course_catalog', params: { id: 0 } })" :disable="disableEditCatalog" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td key="id" :props="props" auto-width>
                    {{ props.row.id }}
                </q-td>

                <q-td key="code" :props="props">
                    {{ props.row.code }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="description" :props="props">
                    {{ $truncateLink(props.row.description) }}
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="$router.push({ name: 'course_catalog', params: { id: props.row.actions } })" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip') }}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" :disable="disableEditCatalog" >
                        <q-tooltip>
                            {{ $t('delete_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { LocalStorage } from 'quasar'

export default {
    name: 'AdminCoursesCatalog',

    i18nOptions: { namespaces: ['custom', 'common', 'presential', 'admin'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            courses_catalog: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'code',
                    required: true,
                    label: 'code',
                    align: 'left',
                    field: 'code',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'course_name',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'description',
                    required: true,
                    label: 'description',
                    align: 'left',
                    field: 'description',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            filter: '',
            action_id: '',
            confirm_remove: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: "common/access_token",
            id_user_client_country_selected: "common/id_user_client_country_selected",
            num_rows: "datatable/num_rows",
            user_module_items: 'common/user_module_items',
            id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        disableEditCatalog() {
            let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return !client.presential_event_catalog
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/presential_manager/admin_presential_catalog/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.courses_catalog = response.data.results.map(e => {
                    return {
                        ...e,
                        actions: e.id,
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_manager_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS_PRESENTIAL', [response.data])
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/presential_manager/admin_presential_catalog/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    created() {
        this.loadPagination()
        this.fetchLists()
        this.request({ pagination: this.server_pagination })
    }
}
</script>

<style lang="stylus" scoped>

</style>
